import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { PageTitle } from "../../../_metronic/layout/core";
import { PurchasePrintSummary } from "./PurchasePrintSummary";
import BedRockContext from "../../BedRockContext";

export function PurchasePrintSummaryPage() {
    const { id } = useParams();
    const myData = useContext(BedRockContext);

    // Reset toolbar buttons when entering this page
    useEffect(() => {
        myData.setBaseData({ toolBarButtons: [] });
    }, []);

    const breadcrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
        {
            title: "Purchases",
            path: "/purchases-list",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs}>Purchase GRN</PageTitle>
            <PurchasePrintSummary id={id} />
        </>
    );
}
